import { render, staticRenderFns } from "./PopupModal.vue?vue&type=template&id=148e8ba4&scoped=true"
import script from "./PopupModal.vue?vue&type=script&lang=js"
export * from "./PopupModal.vue?vue&type=script&lang=js"
import style0 from "./PopupModal.vue?vue&type=style&index=0&id=148e8ba4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148e8ba4",
  null
  
)

export default component.exports